import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {InfoPrice, InfoPriceNum, InfoPriceTag} from "./style";
import {observer} from "mobx-react";
import {targetAllStatus, getStatusTarget} from "../../../utils/status";
import { getPriceAndUnit } from '../../../utils/tool';

@observer
class PriceItem extends Component {
  static propTypes = {
    itemInfo: PropTypes.object,
  };

  static defaultProps = {
    itemInfo: {},
  };

  renderPriceTag(auctionStatus, listToAuction) {
    let priceTag = '当前价';

    if (!!listToAuction) 
      priceTag = '起始价';
    else
      switch (auctionStatus) {
        case 1:
          priceTag = '当前价';
          break;
        case 2:
          priceTag = '当前价';
          break;
        case 0:
          priceTag = '起始价';
          break;
        default:
          priceTag = '当前价';
          break;
      }
    return <InfoPriceTag>{priceTag}：</InfoPriceTag>
  }

  renderPriceNum(displayStatus, auctionStatus, currentPrice, disposeTotalUnit, listToAuction) {
    // const {auctionStatus, currentPriceWithUnit, separateDispose, disposeTotalUnit} = this.props.realTimeData ? this.props.realTimeData : {};
    // const isDisposedProduct = separateDispose === 1 && disposeTotalUnit;
    let status = targetAllStatus[getStatusTarget(displayStatus, auctionStatus, listToAuction)];
    return <InfoPriceNum color={status.fontColor}>￥{getPriceAndUnit(currentPrice, disposeTotalUnit)}</InfoPriceNum>
  }

  render () {
    const { realTimeData = {} } = this.props || {};
    const { displayStatus, auctionStatus, currentPrice, disposeTotalUnit } = realTimeData;
    // 广交所创建的拍品：0 | undefined: 一般拍品；1: 广交所拍品（开始、结束时间都没有）；2: 广交所拍品（结束时间没有）
    const { listToAuction = 0 } = realTimeData.sysDictValueData || {};

    // 广交所的品只有在“预告中”、“进行中”才展示
    const showPrice = !!currentPrice && (!listToAuction || auctionStatus === 0 || auctionStatus === 1);

    return (!!showPrice ? 
      <InfoPrice>
        {this.renderPriceTag(auctionStatus, listToAuction)}
        {/* 广交所的品，始终展示起拍价，实际数据中，currentPrice始终等于startPrice，因此只修改价格前的文案 */}
        {this.renderPriceNum(
          displayStatus,
          auctionStatus,
          currentPrice,
          disposeTotalUnit,
          listToAuction
        )}
        </InfoPrice>
        : <InfoPrice />
    )
  }
}

export default PriceItem;
